import localStorageEnum from '../enum/localStorageEnum'

export const removeStorage = () => {
	localStorage.removeItem(localStorageEnum.oktaToken)
	localStorage.removeItem(localStorageEnum.codeVerifier)
	localStorage.removeItem(localStorageEnum.accessToken)
	localStorage.removeItem(localStorageEnum.oktaCache)
	localStorage.removeItem(localStorageEnum.user)
}